import { useContext } from 'react';
import ShareContext from 'contexts/share/context';

export const useShare = () => {
  return useContext(ShareContext);
};
